import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function CTABanner() {
  return (
    <section
      className="relative py-20 md:py-28"
      data-testid="cta-banner-section"
    >
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-[#0F0F0F]">
          <div
            aria-hidden
            className="absolute inset-0 opacity-60"
            style={{
              background:
                "radial-gradient(circle at 80% 20%, rgba(255,69,0,0.25), transparent 55%), radial-gradient(circle at 10% 90%, rgba(204,255,0,0.08), transparent 50%)",
            }}
          />
          <div className="relative p-10 md:p-16 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <span className="eyebrow">Ready when you are</span>
              <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-4xl sm:text-5xl md:text-6xl lg:text-7xl mt-5 break-words hyphens-auto">
                Let's make your <br />
                competitors uncomfortable.
              </h2>
            </div>
            <div className="lg:col-span-4 lg:justify-self-end">
              <Link
                to="/contact"
                className="btn-primary !py-5 !px-7 text-base"
                data-testid="cta-banner-button"
              >
                Start a project <ArrowUpRight className="h-5 w-5" />
              </Link>
              <p className="text-xs text-white/55 mt-4">
                Avg. response under 24 hours.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
